import "./App.css";
import "./styles/scss/main.scss";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import RoutesPath from "./core/routes/routes";
import CacheBuster from "react-cache-buster";
import packageInfo from "../package.json";
import Loader from "./components/shared/loader";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { getNotificationPollingStatus, fetchNotifications, setPollingEnabled, setNetworkErrorShown } from "core/redux/notifications/notificationSlice";
import { isLandedCost } from "utils/const";

const POLLING_STATUS_INTERVAL = 10000;
const RECONNECT_PROBE_INTERVAL = 20000;

const App = () => {
  const dispatch = useDispatch();
  const pollingStatus = useSelector((state) => state.notifications.pollingStatus);
  const pollingEnabled = useSelector((state) => state.notifications.pollingEnabled);
  const networkErrorShown = useSelector((state) => state.notifications.networkErrorShown);
  const userId = useSelector((state) => state.profiledata?.data?.userId);
  const prevNetworkErrorRef = useRef(false);

  useEffect(() => {
    const checkPollingStatus = () => {
      if (pollingEnabled) {
        dispatch(getNotificationPollingStatus(userId));
      }
    };

    if (!userId || isLandedCost) return;

    checkPollingStatus();
    if (pollingEnabled) {
      dispatch(fetchNotifications());
    }
    const interval = setInterval(checkPollingStatus, POLLING_STATUS_INTERVAL);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, isLandedCost, pollingEnabled]);

  useEffect(() => {
    if (pollingStatus && !isLandedCost && pollingEnabled) {
      dispatch(fetchNotifications());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pollingStatus, isLandedCost, pollingEnabled]);

  useEffect(() => {
    if (prevNetworkErrorRef.current && !networkErrorShown) {
      toast.success("Connection restored. Syncing notifications...");
    }
    prevNetworkErrorRef.current = networkErrorShown;
  }, [networkErrorShown]);

  useEffect(() => {
    if (pollingEnabled || !userId || isLandedCost) return;

    const probe = () => {
      if (navigator.onLine) {
        dispatch(getNotificationPollingStatus(userId));
      }
    };

    const probeInterval = setInterval(probe, RECONNECT_PROBE_INTERVAL);
    return () => clearInterval(probeInterval);
  }, [dispatch, pollingEnabled, userId]);

  useEffect(() => {
    const handleOnline = () => {
      dispatch(setPollingEnabled(true));
      dispatch(setNetworkErrorShown(false));
    };

    const handleOffline = () => {
      dispatch(setPollingEnabled(false));
      dispatch(setNetworkErrorShown(true));
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [dispatch]);

  return (
    <>
      <CacheBuster currentVersion={packageInfo.version} isEnabled={true} isVerboseMode={false} loadingComponent={<Loader />} metaFileDirectory={"."}>
        <RoutesPath />
      </CacheBuster>
      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
        progress={undefined}
        theme="colored"
        limit={1}
        style={{ zIndex: 99999 }}
      />
    </>
  );
};

export default App;
